module.exports = __webpack_public_path__ + "static/media/01FreshPreservesinitialnotes.a3b32e49.webp";